<template>
  <div class="forget">
    <Head /><Kefu />
    <van-form @submit="nextStep" :show-error="false" v-if="activeTab === 'step1'">
      <div style="color: #7832b0; font-size: 22px; word-break: break-word">
        Please enter the ID number associated with your account.
      </div>
      <van-field
        v-model="params.username"
        maxlength="20"
        placeholder="Document Number"
        :rules="rules.username"
        clearable
      />

      <div class="forget-button">
        <van-button round block color="#7832b0" native-type="submit">Continue</van-button>
      </div>
    </van-form>

    <van-form @submit="submitForm" :show-error="false" v-if="activeTab === 'step2'">
      <van-field
        v-model="params.password"
        type="password"
        maxlength="20"
        placeholder="New Password"
        :rules="rules.password"
        clearable
      />
      <van-field
        v-model="params.doublepassword"
        type="password"
        maxlength="20"
        placeholder="Confirm your password"
        :rules="rules.doublepassword"
        clearable
      />
      <div class="forget-button">
        <van-button round block color="#7832b0" native-type="submit">Presentation</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'step1',
      params: {
        username: '',
        password: '',
        doublepassword: '',
        policy: true
      },
      rules: {
        username: [{ required: true, message: 'Enter a valid document' }],
        password: [
          { required: true, message: 'Password must be at least 6 characters' },
          { validator: this.matchNum, message: 'Password must be at least 6 characters' }
        ],
        doublepassword: [
          { required: true, message: 'Password must be at least 6 characters' },
          { validator: this.matchNum, message: 'Password must be at least 6 characters' },
          {
            validator: this.matchSamePassword,
            message: 'Password entered twice is inconsistent, please re-enter'
          }
        ]
      }
    }
  },
  methods: {
    async nextStep() {
      const res = await this.$request.update({ username: this.params.username })
      if (res.retCode === '000') {
        this.activeTab = 'step2'
      } else {
        this.$toast.fail(res.result)
      }
    },
    matchSamePassword(val) {
      if (val === this.params.password) return true
      else return false
    },
    matchNum(val) {
      if (val && val.length >= 6) return true
      else return false
    },
    async submitForm() {
      const that = this
      // 修改密码
      const res = await this.$request.updatePassword(that.params)
      if (res.retCode === '000') {
        that.$router.push('/login')
      } else {
        this.$toast.fail('The account does not exist')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.forget {
  min-height: 100vh;
  background-color: #fff;
  text-align: center;
  :deep(.van-tabs__line) {
    width: 1.875rem;
  }
  .van-form {
    padding-top: 10px;
    overflow: hidden;
    margin-top: 100px;
    margin-left: 30px;
  }

  &-button {
    margin: 30px 16px 16px;
    width: 264px;
  }
}
</style>
